<div class="modal-header">
    <b>Notifica</b>
    <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="close('');" >
            <i class="fas fa-times"></i>
        </button>
    </div>
</div>
<div class="modal-body">
    <!-- Seleziona del modello-->
    <ng-container *ngIf="step==0">
        <ng-container *ngIf="loading">
            <div class="m-5 text-center text-secondary">
                <i class="icon fas fa-info-circle mr-2"></i><i>Caricamento del modello in corso ...</i>                
            </div>
        </ng-container>
        <ng-container *ngIf="!loading">
            <div *ngIf="!notifications || notifications.length==0">
                <div class="m-5 text-center">
                    <i class="fas fa-exclamation-circle mr-2"></i>Nessun modello di notifica è presente per questo elemento.
                </div>
            </div>
            <div class="" *ngIf="id_notification==0">
                <div class="row" *ngIf="notifications && notifications.length>0">                    
                    <div class="col-lg-9">
                        <ng-container *ngFor="let n of notifications">
                            <button class="btn btn-outline-primary btn-block" (click)="selectedNotify=n; getNotification()">{{n.name}}</button>
                        </ng-container>
                    </div>
                    <div class="col-lg-3 border-left text-xs d-none d-lg-block">
                        <i class="fa fa-info-circle fa-3x text-gray mb-2"></i><br>
                        Scegli il modello di notifica da utilizzare
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container >
    <!-- Compilazione modello -->
    <ng-container *ngIf="step==1">
            <div class="row" *ngIf="notifications && notifications.length>0">
                <div class="col-lg-2">
                    <div class="d-none d-lg-block w-100 text-center text-primary">Canali di comunicazione</div>
                    <ul class="nav nav-pills flex-column">
                        <ng-container *ngFor="let g of gateway_notifications;let i=index">
                            <li>
                                <a class="nav-link border d-flex align-items-center justify-content-between" [class.active]="tab==i" (click)="tab=i">                                
                                    <span *ngIf="g.gateway=='email'"><i class="far fa-envelope mr-2"></i>Email</span>
                                    <span *ngIf="g.gateway=='sms'"><i class="fas fa-sms mr-2"></i>SMS</span>
                                    <span *ngIf="g.gateway=='whatsapp'"><i class="fab fa-whatsapp mr-2"></i>WhatsApp</span>
                                    <span *ngIf="g.gateway=='app'"><i class="far fa-bell mr-2"></i>Push notification (App)</span>
                                    <input type="checkbox" [(ngModel)]="g.enable">
                                </a>
                            </li>
                        </ng-container>
                    </ul>
                </div>
                <div class="col-lg-10">            
                    <div class="tab-content" id="myTab2Content">
                        <ng-container *ngFor="let g of gateway_notifications;let i=index">
                            <div class="tab-pane fade" [class.active]="tab==i" [class.show]="tab==i">
                                <app-gateway [gateway]="g" [contacts]="contacts" [record]="record"></app-gateway>
                            </div>
                        </ng-container>
                    </div>               
                    <div class="pt-2 float-right">
                        <button class="btn btn-secondary" (click)="close('');">Annulla</button>
                        <button *ngIf="step==1" (click)="close('success');" class="btn btn-success"><i class="far fa-paper-plane mr-2"></i>Invia</button>
                    </div>
                 </div>
            </div>
        
    </ng-container>